import css from './index.module.css';
import SEO from "@components/seo";
import useUserData from "@hooks/useUserData";
import MainContent from "@components/content";
import MiniProduct from '@components/miniProduct';

export default function Favorites() {
  const { favoriteData } = useUserData();

  return (
    <MainContent header="Избранные товары">    
      <SEO 
        title={`Избранные товары`}
        description={`Избранные товары`}
        ogImage={``}
        ogUrl={``}
      />

      <div className={css.productList}>
        {favoriteData && favoriteData.map(favorite => (
          <MiniProduct
            id={favorite.productId}
            product={favorite.product}
            title={favorite.product.name}
            price={favorite.product.price}
            image={favorite.product.images[0]}
            unit={favorite.product.unit}
            quantity={0}
          />
        ))}
      </div>
    </MainContent>
  )
}